<form *ngIf="form" [formGroup]="form">
  <div class="row">
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>C.I del Cliente *</mat-label>
        <input
          type="text"
          ciRif
          formControlName="ci"
          matInput
          placeholder="V12345678"
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Nombre del Cliente *</mat-label>
        <input
          type="text"
          formControlName="clientName"
          matInput
          placeholder="John"
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>Apellido del Cliente *</mat-label>
        <input
          type="text"
          formControlName="clientLastname"
          matInput
          placeholder="Doe"
        />
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>Tipo de cliente * </mat-label>
        <mat-select placeholder="Tipo de cliente" formControlName="clientType">
          <mat-option *ngFor="let type of typesOfClient" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>Region del cliente *</mat-label>
        <mat-select
          placeholder="Region del cliente"
          formControlName="clientRegion"
        >
          <mat-option *ngFor="let region of regionOfClient" [value]="region">
            {{ region }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6">
      <!-- <mat-form-field appearance="outline">
        <mat-label>Nivel de riesgo *</mat-label>
        <mat-select placeholder="Nivel de riesgo" formControlName="riskLevel">
          <mat-option *ngFor="let level of riskLevels" [value]="level.value">
            {{ level.name }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de ingreso de la alerta *</mat-label>
        <input
          type="date"
          formControlName="dateAlert"
          matInput
          placeholder="Fecha de ingreso de la alerta"
        />
      </mat-form-field>
    </div>
  </div>
</form>
